import { useMemo, useState } from 'react';
import { Dialog, useMediaQuery, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DefaultCompany from '../../../icons/building_round.svg';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import ModalSlider from '../../../components/ModalSlider';

const useStyles = ({ isXS }) => ({
  imageWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginBottom: isXS ? '0px' : '8px',
  },
  dialogCompanyImage: {
    width: '73px',
    height: '73px',
    maxHeight: '73px',
    maxWidth: '73px',
    borderRadius: '146px',
    marginBottom: isXS ? 0 : '4px',
    cursor: 'pointer',
  },
  dialogContainer: {
    padding: isXS ? '0px' : '10px',
  },
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    width: isXS ? '' : '600px',
    height: 'auto',
    alignItems: 'center',
    background: '#FFFFFF',
    borderRadius: isXS ? '0px' : '15px',
    paddingTop: isXS ? '24px' : '24px',
    paddingBottom: isXS ? '0px' : '30px',
  },
});

export default function FirstViewModal({
  companyBoardData,
  isFirstViewModalVisible,
  setIsFirstViewModalVisible,
}) {
  const [activeStep, setActiveStep] = useState(0);
  const [blockClosePopup, setBlockClosePopup] = useState(false);
  const srcImage = useMemo(() => {
    if (companyBoardData?.image?.id) {
      return `${process.env.REACT_APP_IMAGES_URL}${companyBoardData.image.id}`;
    }
    return DefaultCompany;
  }, [companyBoardData]);

  const steps = useMemo(() => {
    return [
      <Step1
        companyBoardData={companyBoardData}
        setActiveStep={setActiveStep}
      />,
      <Step2
        companyBoardData={companyBoardData}
        setActiveStep={setActiveStep}
        setBlockClosePopup={setBlockClosePopup}
      />,
      <Step3
        companyBoardData={companyBoardData}
        setActiveStep={setActiveStep}
        setBlockClosePopup={setBlockClosePopup}
      />,
      <Step4 setActiveStep={setActiveStep} handleClose={handleClose} />,
    ];
  }, []);

  function handleClose() {
    if (blockClosePopup) {
      return;
    }
    setIsFirstViewModalVisible(false);
    setActiveStep(0);
  }

  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const classes = useStyles({ isXS });

  return (
    <Dialog
      open={isFirstViewModalVisible}
      sx={classes.dialogContainer}
      fullScreen={isXS}
      PaperProps={{ style: { borderRadius: { xxs: 0, sm: 15 } } }}
      onClose={handleClose}
    >
      <div style={classes.dialog}>
        {isXS && (
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{ position: 'absolute', top: 0, right: 0 }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <div role="none" style={classes.imageWrapper}>
          <img
            alt="Company Avatar"
            className="profileAvatar"
            style={classes.dialogCompanyImage}
            src={srcImage}
          />
        </div>
        <ModalSlider steps={steps} activeStep={activeStep} />
      </div>
    </Dialog>
  );
}
